const PopDomain = `PopupModalMFA`;
const ComponentsDomain = 'ComponentsMFA';

export { ComponentsDomain, PopDomain };
